"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var Button_1 = __importDefault(require("@components/Button"));
var react_hook_form_1 = require("react-hook-form");
var clsx_1 = __importDefault(require("clsx"));
var _store_1 = require("@store");
var react_redux_1 = require("react-redux");
var settingsSlice_1 = require("@features/SettingsPage/state/settingsSlice");
var constants_1 = require("@common/constants");
var TEAM_NAME_MAX_LENGTH = 30;
function TeamGeneralSetting(props) {
    var _a, _b, _c, _d;
    var domain = props.domain, siteNameChanged = props.siteNameChanged;
    var t = (0, react_i18next_1.useTranslation)(['settings']).t;
    var dispatch = (0, _store_1.useAppDispatch)();
    var loading = (0, react_redux_1.useSelector)(settingsSlice_1.loadingSelector);
    var error = (0, react_redux_1.useSelector)(settingsSlice_1.errorSelector);
    // probably the default value inside slice for siteDetails could be some
    // object with empty string values instead of null
    var siteDetails = (0, react_redux_1.useSelector)(settingsSlice_1.siteDetailsSelector);
    var _e = siteDetails !== null && siteDetails !== void 0 ? siteDetails : { name: '', company: '' }, name = _e.name, company = _e.company;
    var getSettings = function () { return dispatch((0, settingsSlice_1.fetchSiteDetails)(domain)); };
    var _f = (0, react_hook_form_1.useForm)(), register = _f.register, handleSubmit = _f.handleSubmit, errors = _f.formState.errors, formState = _f.formState;
    (0, react_1.useEffect)(function () {
        getSettings();
    }, [domain]);
    var onSubmit = function (siteDetails) {
        dispatch((0, settingsSlice_1.persistSiteDetails)(domain, siteDetails));
        siteNameChanged();
    };
    var filterUnsafeOnBlur = function (e) {
        var value = e.currentTarget.value;
        var filteredData = value.replace(new RegExp("[".concat(constants_1.unsafeCharacters.join(''), "]"), 'g'), '');
        if (value !== filteredData) {
            e.currentTarget.value = filteredData;
        }
    };
    return (react_1.default.createElement("div", { className: "col-xs-9 component" },
        react_1.default.createElement("div", { className: "team-general-settings" },
            react_1.default.createElement("div", { className: "setting__title" }, t('settings:GENERAL.TITLE')),
            error && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("p", null, t('settings:FAILED_TO_LOAD_SETTINGS_MESSAGE')),
                react_1.default.createElement(Button_1.default, { onClick: getSettings, text: t('settings:GENERAL.TRY_AGAIN_BUTTON') }))),
            !error && !loading && (react_1.default.createElement("form", null,
                react_1.default.createElement("label", { className: "setting__label", htmlFor: "name" }, t('settings:GENERAL.CHANGE_TEAM_NAME_TEXT')),
                react_1.default.createElement("input", __assign({ className: (0, clsx_1.default)('team-general-settings__input', errors.name && 'eva-input--invalid'), defaultValue: name }, register('name', { required: true, maxLength: TEAM_NAME_MAX_LENGTH }), { onKeyDown: function (e) { return constants_1.unsafeCharacters.includes(e.key) && e.preventDefault(); }, onBlur: filterUnsafeOnBlur })),
                react_1.default.createElement("p", { className: "setting__error" },
                    ((_a = errors.name) === null || _a === void 0 ? void 0 : _a.type) === 'required' && t('settings:GENERAL.TEAM_NAME_EMPTY'),
                    ((_b = errors.name) === null || _b === void 0 ? void 0 : _b.type) === 'maxLength' && t('settings:GENERAL.TEAM_NAME_TOO_LONG')),
                react_1.default.createElement("label", { className: "setting__label", htmlFor: "company" }, t('settings:GENERAL.CHANGE_COMPANY_NAME_TEXT')),
                react_1.default.createElement("input", __assign({ className: (0, clsx_1.default)('team-general-settings__input', errors.company && 'eva-input--invalid'), defaultValue: company }, register('company', { required: true, maxLength: TEAM_NAME_MAX_LENGTH }), { onKeyDown: function (e) { return constants_1.unsafeCharacters.includes(e.key) && e.preventDefault(); }, onBlur: filterUnsafeOnBlur })),
                react_1.default.createElement("p", { className: "setting__error" },
                    ((_c = errors.company) === null || _c === void 0 ? void 0 : _c.type) === 'required' && t('settings:GENERAL.COMPANY_NAME_EMPTY'),
                    ((_d = errors.company) === null || _d === void 0 ? void 0 : _d.type) === 'maxLength' && t('settings:GENERAL.COMPANY_NAME_TOO_LONG')),
                react_1.default.createElement(Button_1.default, { text: t('settings:GENERAL.SAVE_BUTTON'), onClick: handleSubmit(onSubmit), disabled: formState.isSubmitted && !formState.isValid }))))));
}
exports.default = TeamGeneralSetting;
